export const ProfileActions = {
  bindings: {
    isLoading: '<',
    isDisabled: '<',
    ngType: '@',
    onCancel: '&',
    onSubmit: '&',
  },

  template: `
    <div class="form-row justify-content-end">
      <div class="col-md-8" ng-switch="$ctrl.ngType">
        <hr class="mt-0 mb-4">
        <span class="mr-2">
          <button class="btn btn-link"
            type="button"
            ng-disabled="$ctrl.isLoading"
            ng-click="$ctrl.onCancel()">
            Cancel
          </button>
        </span>
        <span ng-switch-when="button">
          <button-primary
            ng-type="button"
            ng-disabled="$ctrl.isDisabled"
            on-click="$ctrl.onSubmit()">
            <spinner is-loading="$ctrl.isLoading">
              Submit
            </spinner>
          </button-primary>
        </span>
        <span ng-switch-default>
          <button-primary
            ng-type="submit"
            ng-disabled="$ctrl.isDisabled">
            <spinner is-loading="$ctrl.isLoading">
              Submit
            </spinner>
          </button-primary>
        </span>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileActions.js